import React from 'react';

import { useLocation, useParams } from 'react-router-dom';

import { get as getConstants } from '@lumapps/constants';

import { Route } from '../types';
import { useQueryParams } from './useQueryParams';

const { applicationId } = getConstants();

/**
 * Retrieves the currently applied route.
 * @returns Route
 */
export const useCurrentRoute = (): Route => {
    const { pathname } = useLocation();
    const routeParams = useParams();
    const queryParams = useQueryParams();

    return React.useMemo(
        () => ({
            path: pathname,
            query: queryParams,
            params: routeParams,
            appId: applicationId,
        }),
        [pathname, routeParams, queryParams],
    );
};
